import type { ContentMediaKind, ContentMediaSignResponse, ContentMediaSignResult, SignContentMediaBody } from './types';

export function mapContentMediaSignResult(data: ContentMediaSignResponse): ContentMediaSignResult {
  return {
    url: data.url,
    signedRequest: data.signed_request,
  };
}

/** The sign body for a picked file; its MIME type must match `kind`. */
export function toSignContentMediaBody(
  file: Pick<File, 'name' | 'type'>,
  kind: ContentMediaKind
): SignContentMediaBody {
  /* eslint-disable camelcase */
  return {
    file_name: file.name,
    file_type: file.type,
    kind,
  };
  /* eslint-enable camelcase */
}
